
<template>
  <div>
    <van-nav-bar :fixed="true" left-arrow @click-left="$router.back()">
      <template slot="title">
        <span class="title">公共池客户列表</span>
      </template>
    </van-nav-bar>
    <div class="top"></div>

    <!-- <van-pull-refresh v-model="refreshing" > -->
    <!-- @refresh="onRefresh" -->
    <!-- <van-list
        :immediate-check="false"
        offset="200"
        v-model="loading"
        :finished="finished"
        :finished-text="dataList.length>0?'没有更多了':'没有客户数据，请先录入'"
        @load="onLoad"
      > -->
      <div>
    <div class="listbody"> 
      <user-item
        v-for="(user, i) in dataList"
        :key="i"
        :user="user"
        @click="$emit('click', user)"
      ></user-item>
    </div>
    <div class="footer">
      <van-button type="primary" block @click="getList()">下一批</van-button>
    </div>
      </div>
    <!-- </van-list> -->
    <!-- </van-pull-refresh> -->
  </div>
</template>
<script>
import Detail from "../returnvisit/detail.vue";
import UserItem from "./item";

export default {
  name: "commodityList",
  components: {
    UserItem,
    Detail,
  },

  props: ["req", "title"],

  data() {
    return {
      searchStr: "",
      //imgUrlPath: ImgUrlPath.ImgUrlPath,
      offset: 100,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      // curtime: new Date().getTime()
    };
  },
  watch: {
    // commodity(newV,oldV) {
    //   this.onRefresh();
    // }
  },
  methods: {
    inSelect(user) {
      console.log(user);
    },
    onCancel() {
      this.pagenum = 1;
      this.searchStr = "";
      this.getList();
    },
    onRefreshStart() {
      this.pagenum = 1;

      this.getList();
    },
    checkOper() {
      for (var i in this.list) {
        if (this.list[i].扫客状态 == undefined) return false;
      }
      return true;
    },
    // 获取数据
    getList() {
      if (this.checkOper() == false) {
        this.$toast({
          message: "请操作完本页客户后再刷新",
        });
        return;
      }
      this.loading = true;
      let data = {
        paging: {
          limit: 10,
          page: this.pagenum,
        },
      };
      console.log("req", this.req);

      data.req = {};

      this.$request
        .customerPublicList(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          if (res.code == 0) {
            if (this.pagenum == 1) {
              this.list = res.data.items;
            } else {
              this.list = this.list.concat(res.items);
            }
            this.dataList = this.list;
            // this.total = res.data.total;

            // if (this.dataList.length >= res.data.total) {
            //   this.finished = true;
            // }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },

    onRefresh() {
      this.pagenum = 1;
      this.finished = false;

      this.getList();
      this.refreshing = false;
    },
    onLoad() {
      this.pagenum++;
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
      // this.$store.dispatch("setCacheObjFirstLoad", false);
      // this.onRefresh()
    });
  },
};
</script>
<style scoped lang="less">
.footer {
}
.top {
  margin-top: 50px;
}
.listbody{
  height: calc ( 100vh - 120px);
  overflow: scroll;
}
#commodityList {
  margin-top: 10px;
  padding: 0 10px;

  .commodityBox {
    flex-wrap: wrap;
    font-size: 14px;

    .commodityContainer {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px !important;
      border-radius: 20px;

      // box-shadow: #666 5px 5px 5px;
      .textBox {
        margin: 5px 0px 5px 0px;

        .colon {
          display: inline-block;
          margin: 0 4px;
          color: black;
        }

        .block {
          display: inline-block;
          width: 30px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: #ee0a24;
        }

        .batch {
          color: green;
        }

        .batch p {
          margin: 3px;
        }
      }
    }
  }
}
</style>